$(document).ready(function() {
// ==============================if login and data available --- checkout button clickable ====================================
// $.ajax({
//     type: 'GET',
//     url: '/cart.js',
//     dataType: 'json',
//     success: function(cartdata) {
//         if (cartdata.attributes && Object.keys(cartdata.attributes).length > 0 && cartdata.attributes.address1 ) {
//              $('#selectedSuggestion div.selected_value').text(`${cartdata.attributes.address1}, ${cartdata.attributes.address2}, ${cartdata.attributes.province},  ${cartdata.attributes.postalCode}`);
//               $('#selectedSuggestion').show();
//             $.each(cartdata.attributes, function(key, value) {
//                 // console.log("key",key)
//                 if(key === "address1"){
//                     console.log("true")
//                         $("[name='checkout']").removeAttr("disabled");
//                 }
//             });
//         } else {
//             console.log('No attributes found in the cart.');
//         }
//     },
//     error: function(xhr, status, error) {
//         console.error('Error fetching cart data:', error);
//     }
// });

  //======================================== Select delivery method ========================================== 
                      $('.delivery-options input[type=radio]').change(function() {
                             // console.log("THis", this , this.value);
                             $("#delivery-method").val(this.value);
                             if(this.value == "delivery"){
                                              $(".delivery-messages p.pickup-message").hide();
                                              $(".delivery-option").removeClass("active");
                                              $(this).parents(".delivery-option").addClass("active");
                                               $.ajax({
                                                type: 'GET',
                                                url: '/cart.js',
                                                dataType: 'json',
                                                success: function(cartdata) {
                                                    if (cartdata.attributes && Object.keys(cartdata.attributes).length > 0 && cartdata.attributes.address1 ) {
                                                         $.ajax({
                                                          url: '/cart/update.js',
                                                          type: 'POST',
                                                          data: {
                                                          attributes: {
                                                              "address1": "",
                                                              "address2": "",
                                                              "province": "",
                                                              "country": "",
                                                              "postalCode": "",
                                                              "branchCode": "",
                                                              "branchName": "",
                                                              "delivery_address_clear" : "1"
                                                          }
                                                          },
                                                          dataType: "json",
                                                          success: function(data) {         
                                                              console.log("Added attribute delivery_address_clear")
                                                          },
                                                          error: function(error) {
                                                              console.log("error", error);
                                                          }
                                                      });
                                      
                                              } else {
                                                   $.ajax({
                                                    url: '/cart/update.js',
                                                    type: 'POST',
                                                    data: {
                                                    attributes: {
                                                        "address1": "",
                                                        "address2": "",
                                                        "province": "",
                                                        "country": "",
                                                        "postalCode": "",
                                                        "branchCode": "",
                                                        "branchName": "",
                                                        "delivery_address_clear" : "0"
                                                    }
                                                    },
                                                    dataType: "json",
                                                    success: function(data) {         
                                                      console.log("remove attribute delivery_address_clear")
                                                    },
                                                    error: function(error) {
                                                        console.log("error", error);
                                                    }
                                                });
                                              }
                                          },
                                          error: function(xhr, status, error) {
                                              console.error('Error fetching cart data:', error);
                                          }
                                      });  
                                          $(".delivery-store-selector").hide();
                                          $("[name='checkout']").removeAttr("disabled");
                                          $(".delivery-messages p.delivery-message").css("display", "flex");
                          }else{
                               //===========================  For Pickup ================================================== 
                                $(".delivery-option").removeClass("active");
                                $(this).parents(".delivery-option").addClass("active");
                                $(".delivery-store-selector").show();
                                $(".delivery-messages p.pickup-message").css("display", "flex");
                                $(".delivery-messages p.delivery-message").hide();
                                $("[name='checkout']").attr("disabled", "true");       
                          }
                      
                      });

// ================================= End document ready =========================================
  });
// =============================================Get geo location based on  postral code =================================================================
function geocodePostalCode(postalCode, country, callback) {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 
        'address': postalCode,
        'componentRestrictions': { 'country': country } // Specify the country
    }, function(results, status) {
        if (status === 'OK' && results.length > 0) {
            var location = results[0].geometry.location;
            callback(null, location);
        } else {
            callback(new Error("Could not find location for postal code: " + postalCode));
        }
    });
}


function calculateDistance(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the Earth in kilometers      
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var distance = R * c; // Distance in kilometers
    return distance;
}

function toRad(value) {
    return value * Math.PI / 180;
}

// ============================================== Api for get all store data ===========================================
    var storeData = []; // Initialize an empty array

    // Fetch store data once and cache it
    async function fetchStoreData() {
        try {
            const response = await $.ajax({
                url: get_all_store_data,
                type: 'GET',
                dataType: 'json',
                headers: {
                   Authorization: "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B",
                },              
            });
            storeData = response;
          console.log("this is to see if it fetching data ");
        } catch (error) {
            console.error("Error fetching data", error);
        }
    } 
    async function initMap(){
        const { Autocomplete } = await google.maps.importLibrary("places");
        const autocomplete = new Autocomplete($("#location_search")[0], {
            componentRestrictions: { country: "ZA" }
        });

        autocomplete.addListener('place_changed', function() {
            const place = autocomplete.getPlace();
            if (!place || !place.geometry) {
                console.error("No geometry returned from place selection");
                return;
            }

            const sel_lati = parseFloat(place.geometry.location.lat());
            const sel_longi = parseFloat(place.geometry.location.lng());
            if (!Number.isFinite(sel_lati) || !Number.isFinite(sel_longi)) {
                console.error("Invalid coordinates from place selection", sel_lati, sel_longi);
                return;
            }

            showSuggestions(sel_lati, sel_longi);
        });

      // =====================================  Click for current location ======================================
              $(".location-message a").on('click', function () {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                         // console.log("position", position)
                   
                        var lat = position.coords.latitude;
                        var lng = position.coords.longitude;
                         showSuggestions(lat , lng);
                    }, function (error) {
                        console.error("Error getting location: " + error.message);
                    });
                } else {
                    alert("Geolocation is not supported by this browser.");
                }
            });
    }

// ===============================================  Clear button =============================================
 $(document).on("click",".clear-select-store #clear_store",function() {
    $('#selectedSuggestion').hide();
    $("#location_search").val("");
    $("[name='checkout']").attr("disabled", true);
    $(this).closest(".clear-select-store").hide();
        // showSuggestions();
    });
// ========================================= F for showSuggestions  ================================================
function showSuggestions(latitude , longitude) {
    const inputPostalCode = latitude || longitude || $('#location_search').val().trim();    
    if (!inputPostalCode) {
        $('#searchResults').hide();
        return;
    }
              const inputLat = latitude;
              const inputLng = longitude;
              const suggestions = [];
    
        // Filter stores within 30km range
        storeData.forEach(store => {
            const storeLat = store.latitude;
            const storeLng = store.longitude;
        // console.log("storeLat", storeLat , "storeLng", storeLng)
            if (storeLat && storeLng) {
                const distance = calculateDistance(inputLat, inputLng, storeLat, storeLng);
                  // console.log("distance", distance)
                if (distance <= 1000) { // Filter by 1000KM range
                   const storeWithDistance = {
                        ...store,
                        distance: distance.toFixed(2) // Adding distance and formatting to 2 decimal places
                    };
                    suggestions.push(storeWithDistance);
                }
            }
        });

        // Display the filtered store suggestions
        if (suggestions.length > 0) {
            // console.log('Suggestions:', suggestions);
            suggestions.sort((a, b) => a.distance - b.distance); // This will log the stores in the upper/global level           
            displaySuggestions(suggestions); // Implement this function to display the suggestions
        } else {
            alert("No stores found withinrange.");
        }

}

// ========================================= F for displaySuggestions  ================================================  
   function displaySuggestions(suggestions) {
        const suggestionBox = $('#searchResults');
        suggestionBox.empty(); // DD Clear previous suggestions
        suggestions.forEach((suggestion, index) => {
            // console.log("index", index)
               if(index <= 2) { //========= Indext start from 0 so we can show the only  3 result with this condition
                  // Parse the opening hours JSON
                  var schedule = JSON.parse(suggestion.openingHours);    
                  var formattedHours = '';                  
                  // Loop through each day and format the opening hours
                  $.each(schedule, function(day, times) {
                  var open = times.open ? times.open : "Closed";
                  var close = times.close ? times.close : "Closed";
                  var allDay = times.all_day ? "Open All Day" : open + " - " + close;
                  
                  // Append the day and its corresponding times to the formattedHours string
                  formattedHours += `<div><strong>${day.charAt(0).toUpperCase() + day.slice(1)}:</strong> ${allDay}</div>`;
                  });
                  const div = $('<div>').addClass('suggestion').html(`<div class="wrp-main"><div class="radio-and-title"><div class="radio-button"></div><div class="store-title"><div class="short_name"> ${suggestion.shortStoreName}</div><div class="store-distance"> ${suggestion.distance} Km away</div></div></div><div class="store-toggle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#B0B0B0"/> </svg></div></div><div class="store-details"><div class="store-detail store_location"><div class="title">Store location</div><div class="detail">${suggestion.address1},${suggestion.address2}</div></div><div class="store-detail store_contact"><div class="title">Contact Details</div><div class="detail"><a href="tel:${suggestion.phone}">${suggestion.phone}</a></div></div><div class="store-detail store_hours"><div class="title">Business hours</div><div class="detail">${formattedHours}</div></div></div>`);                
                  div.on('click',".wrp-main .radio-and-title", () => selectSuggestion(suggestion));
                  suggestionBox.append(div);
             }
        });
        // console.log("suggestions==>", suggestions)
        if (suggestions.length === 0) {
            suggestionBox.hide();
        } else {
            suggestionBox.show();
            $(".suggestion .store-toggle").click(function() {
                $(this).parents(".suggestion").siblings().find(".store-details").hide();
                $(this).parents(".suggestion").find(".store-details").toggle();
            });

        }
     $(".clear-select-store").hide();
    }
// =========================================== F for selectSuggestion =========================================
function selectSuggestion(suggestion) {
    console.log("suggestions==>", suggestion);

    // Parse the opening hours JSON
    var schedule = JSON.parse(suggestion.openingHours);    
    var formattedHours = '';

    // Loop through each day and format the opening hours
    $.each(schedule, function(day, times) {
        var open = times.open ? times.open : "Closed";
        var close = times.close ? times.close : "Closed";
        var allDay = times.all_day ? "Open All Day" : open + " - " + close;

        // Append the day and its corresponding times to the formattedHours string
        formattedHours += `<div><strong>${day.charAt(0).toUpperCase() + day.slice(1)}:</strong> ${allDay}</div>`;
    });

    // Construct the selected value HTML
    const selectedValue = `
        <div class="wrp-main">
            <div class="radio-and-title">
                <div class="radio-button"></div>
                <div class="store-title">
                    <div class="short_name">${suggestion.shortStoreName}</div>
                    <div class="store-distance">${suggestion.distance} km away</div>
                </div>
            </div>
            <div class="store-toggle">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#B0B0B0"/>
                </svg>
            </div>
        </div>
        <div class="store-details">
            <div class="store-detail store_location">
                <div class="title">Store location</div>
                <div class="detail">${suggestion.address1}, ${suggestion.address2}</div>
            </div>
            <div class="store-detail store_contact">
                <div class="title">Contact Details</div>
                <div class="detail"><a href="tel:${suggestion.phone}">${suggestion.phone}</a></div>
            </div>
            <div class="store-detail store_hours">
                <div class="title">Business hours</div>
                <div class="detail">${formattedHours}</div>
            </div>
        </div>`;

    // Set the search bar value to the selected suggestion
    $('#address1').val(suggestion.address1 ? `${suggestion.address1}` : `${suggestion.address2}`);
    $('#address2').val(suggestion.address2 ? `${suggestion.address2}` : `${suggestion.address1}`);
    $('#province').val(`${suggestion.province}`);
    $('#postalCode').val(`${suggestion.postalCode}`);    
    $('#country').val(`${suggestion.country}`);
    $('#branchCode').val(`${(suggestion.branchCode).replace(/\D/g, '').padStart(4, '0')}`);
    $('#branchName').val(`${suggestion.shortStoreName}`);
    $('#searchBar').val(selectedValue);        

    // Hide the suggestion box
    $('#searchResults').hide();        
    $("div#selectedSuggestion, .clear-select-store").show();
    $(".delivery-messages p.pickup-message").css("display", "flex");
    // Show the selected suggestion in the specified HTML element
    $('#selectedSuggestion div.selected_value').html(selectedValue);

    // Enable the checkout button
    $("[name='checkout']").removeAttr("disabled");
     all_clicks();
}
// ============================  F for all clicks=================
function all_clicks(e) {
  $(".store-toggle").click(function(){
   $(this).parents(".selected_value").find(".store-details").toggle();
});
}

document.addEventListener('DOMContentLoaded', async function() {
    await fetchStoreData(); // Fetch store data first
    initMap();     
});

  
